export const handleizeString = (string) => string.toLowerCase().replace(/ /g, '-');

export const truncateWords = (str, words) => `${str.split(' ').splice(0, words).join(' ')}...`;

export const prependZero = (string) => (`0${string}`).slice(-2);

export default {
  handleizeString,
};
